import React from "react";

class Alert extends React.Component {
    state = {
        show: true
    };

    render() {
        const { message, type } = this.props;
        if (!this.state.show) {
            return null;
        }
        return (
            <div
                className={`alert alert-${type} alert-dismissible`}
                role="alert"
            >
                {message}
                <button
                    type="button"
                    className="close"
                    aria-label="Close"
                    onClick={() => this.setState({ show: false })}
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
        );
    }
}
export default Alert;



// WEBPACK FOOTER //
// ./src/components/widgets/Alert/Alert.js